import React from 'react';
import { Check, X } from 'lucide-react';
import { motion } from 'framer-motion';
import { BenefitIcon } from './graphics/Graphics';
export function ProductReveal() {
  return <section className="bg-forest py-16 md:py-20 px-5" data-id="element-475">
      <div className="max-w-[780px] mx-auto" data-id="element-476">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-477">
          <div className="font-inter text-[12px] uppercase tracking-[0.1em] text-white/60 mb-3" data-id="element-478">
            The Solution
          </div>
          <h2 className="font-playfair text-[32px] md:text-[36px] text-white font-semibold mb-4" data-id="element-479">
            Introducing DryControl™
          </h2>
          <p className="font-inter text-[18px] text-white/80 max-w-[500px] mx-auto" data-id="element-480">
            The incontinence patch designed for the nerve-muscle communication
            layer
          </p>
        </div>

        {/* Two Column Layout */}
        <div className="flex flex-col md:flex-row gap-10 items-center mb-16" data-id="element-481">
          {/* Left: Image */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-1/2" data-id="element-482">
            <img src="https://cdn.magicpatterns.com/uploads/76giWEKFtRzKs5cL1WHkBZ/ChatGPT_Image_May_8,_2026,_04_08_23_PM.png" alt="DryControl Patch and Packaging" className="w-full h-auto rounded-xl shadow-subtle object-cover aspect-square" data-id="element-483" />
          </motion.div>

          {/* Right: Benefits */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-1/2 space-y-4" data-id="element-484">
            {[{
            icon: 'transdermal' as const,
            text: 'Transdermal delivery to nerve pathways'
          }, {
            icon: 'sleep' as const,
            text: 'Works while you sleep'
          }, {
            icon: 'no-routine' as const,
            text: 'No daily routine or application process'
          }, {
            icon: 'clean' as const,
            text: 'No hormones, no steroids, no parabens'
          }, {
            icon: 'women' as const,
            text: 'Developed for women over 50'
          }, {
            icon: 'fast' as const,
            text: 'Results from day 4–7'
          }].map((benefit, index) => <div key={index} className="flex items-start" data-id="element-485">
                <div className="w-9 h-9 rounded-full border border-gold/40 bg-white/5 flex items-center justify-center shrink-0 mr-4" data-id="element-486">
                  <BenefitIcon type={benefit.icon} className="w-5 h-5" color="#C9A96E" data-id="element-487" />
                </div>
                <span className="font-inter text-[16px] text-white pt-1.5" data-id="element-488">
                  {benefit.text}
                </span>
              </div>)}
          </motion.div>
        </div>

        {/* Comparison Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-xl p-6 md:p-8 overflow-x-auto shadow-subtle mb-10" data-id="element-489">
          <table className="w-full min-w-[500px]" data-id="element-490">
            <thead data-id="element-491">
              <tr className="border-b border-divider" data-id="element-492">
                <th className="text-left py-3 font-inter font-semibold text-[15px] text-ink w-[40%]" data-id="element-493"></th>
                <th className="text-center py-3 font-inter font-semibold text-[15px] text-secondary w-[20%]" data-id="element-494">
                  Pads
                </th>
                <th className="text-center py-3 font-inter font-semibold text-[15px] text-secondary w-[20%]" data-id="element-495">
                  Kegels
                </th>
                <th className="text-center py-3 font-inter font-bold text-[16px] text-forest w-[20%] bg-forest/5 rounded-t-lg border-l-2 border-forest" data-id="element-496">
                  DryControl
                </th>
              </tr>
            </thead>
            <tbody className="font-inter text-[14px] text-ink" data-id="element-497">
              <tr className="border-b border-divider" data-id="element-498">
                <td className="py-4 pr-4" data-id="element-499">Addresses the leak</td>
                <td className="text-center py-4" data-id="element-500">
                  <Check className="w-5 h-5 text-forest mx-auto" data-id="element-501" />
                </td>
                <td className="text-center py-4" data-id="element-502">
                  <X className="w-5 h-5 text-gold mx-auto" data-id="element-503" />
                </td>
                <td className="text-center py-4 bg-forest/5 border-l-2 border-forest" data-id="element-504">
                  <Check className="w-5 h-5 text-forest mx-auto" data-id="element-505" />
                </td>
              </tr>
              <tr className="border-b border-divider" data-id="element-506">
                <td className="py-4 pr-4" data-id="element-507">Addresses the signal</td>
                <td className="text-center py-4" data-id="element-508">
                  <X className="w-5 h-5 text-gold mx-auto" data-id="element-509" />
                </td>
                <td className="text-center py-4" data-id="element-510">
                  <X className="w-5 h-5 text-gold mx-auto" data-id="element-511" />
                </td>
                <td className="text-center py-4 bg-forest/5 border-l-2 border-forest" data-id="element-512">
                  <Check className="w-5 h-5 text-forest mx-auto" data-id="element-513" />
                </td>
              </tr>
              <tr className="border-b border-divider" data-id="element-514">
                <td className="py-4 pr-4" data-id="element-515">Reduces anxiety over time</td>
                <td className="text-center py-4" data-id="element-516">
                  <X className="w-5 h-5 text-gold mx-auto" data-id="element-517" />
                </td>
                <td className="text-center py-4" data-id="element-518">
                  <X className="w-5 h-5 text-gold mx-auto" data-id="element-519" />
                </td>
                <td className="text-center py-4 bg-forest/5 border-l-2 border-forest" data-id="element-520">
                  <Check className="w-5 h-5 text-forest mx-auto" data-id="element-521" />
                </td>
              </tr>
              <tr data-id="element-522">
                <td className="py-4 pr-4" data-id="element-523">Works while you sleep</td>
                <td className="text-center py-4" data-id="element-524">
                  <Check className="w-5 h-5 text-forest mx-auto" data-id="element-525" />
                </td>
                <td className="text-center py-4" data-id="element-526">
                  <X className="w-5 h-5 text-gold mx-auto" data-id="element-527" />
                </td>
                <td className="text-center py-4 bg-forest/5 rounded-b-lg border-l-2 border-forest" data-id="element-528">
                  <Check className="w-5 h-5 text-forest mx-auto" data-id="element-529" />
                </td>
              </tr>
            </tbody>
          </table>
        </motion.div>

        {/* Patch vs Cream Callout */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="border border-white/20 rounded-xl p-6 md:p-8 mb-10" data-id="element-530">
          <h3 className="font-inter font-semibold text-[18px] text-white mb-3" data-id="element-531">
            Why a patch — not a cream
          </h3>
          <p className="font-inter text-[15px] text-white/85 leading-relaxed" data-id="element-532">
            Creams are messy, require daily application, and absorb unevenly
            depending on your skin's moisture levels. A transdermal patch
            delivers a consistent, steady release exactly where it's needed,
            over a sustained period. You apply it, you forget about it, and it
            does the work for you. It is the ultimate maintenance-free approach.
          </p>
        </motion.div>

        {/* CTA */}
        <div className="text-center" data-id="element-533">
          <button onClick={() => document.getElementById('bundles')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full md:w-auto md:min-w-[320px] bg-white text-forest font-inter font-semibold text-[16px] h-[52px] px-8 rounded-lg hover:bg-offwhite transition-colors shadow-subtle" data-id="element-534">
            Choose Your Bundle — 90-Day Guarantee ↓
          </button>
        </div>
      </div>
    </section>;
}